import { render, staticRenderFns } from "./FrzChamberCustomerBrand.vue?vue&type=template&id=4538e27e"
import script from "./FrzChamberCustomerBrand.vue?vue&type=script&lang=js"
export * from "./FrzChamberCustomerBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports